import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { getTenants, TenantsResponse } from "../services/tenant.service";

const tenantKeys = {
  all: ["tenants"] as const,
  list: () => [...tenantKeys.all, "list"] as const,
};

export const useTenants = (options?: { enabled?: boolean }) => {
  const { getAccessTokenSilently } = useAuth0();

  const query = useQuery<TenantsResponse, Error>({
    queryKey: tenantKeys.list(),
    queryFn: async () => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        },
      });

      const response = await getTenants(token);
      if (response.error || !response.data) {
        throw new Error(response.error || "Failed to load tenants");
      }

      return response.data;
    },
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    enabled: options?.enabled ?? true,
  });

  return query;
};

